module.exports = __webpack_public_path__ + "static/media/fly0280.e48bedf7.webp";